import { ServiceTileType } from '../../cisco/user-detail-home/service-tile-type.model';
import { ZiroIcons } from '../../../shared/models/ziro-icons.enum';

export enum MicrosoftTile {
  MS365 = 'ms365',
  MICROSOFT_TEAMS_CALLING = 'msTeamsCalling',
  MICROSOFT_TEAMS_AUDIO_CONFERENCING = 'msTeamsAudioConferencing',
  DUBBER = 'dubber',
  SECURITY_GROUP_MEMBERSHIP = 'msSecurityGroupMembership',
  CALL_QUEUES = 'callQueues',
  AUTO_ATTENDANTS = 'autoAttendants',
  RESOURCE_ACCOUNTS = 'resourceAccounts',
}

export interface MicrosoftTileState {
  dataAutomation: string;
  serviceType: MicrosoftTile; // matches Tiles enum values, used for dynamic look up
  tileType: ServiceTileType;
  serviceName: string;
  icon: ZiroIcons;
  isAdding: boolean;
  isDeleting: boolean;
  isDisplayed: boolean;
  isEnabled: boolean;
  description?: string;
  tooltip?: string;
  isImmediateCallForwarding?: boolean;
  immediateCallForwardingTooltip?: string;
}
